export const imageCacheUrl = "https://image-cache.akac.workers.dev";
export const iso8601Regex = /^\d{4}(-\d\d(-\d\d(T\d\d:\d\d(:\d\d)?(\.\d+)?(([+-]\d\d:\d\d)|Z)?)?)?)?$/;
